import _ from 'lodash';
import PmsExporter, { ImagesType, PMSConfigurationType, StudyType } from './PmsExporter';
import { Patient } from 'app/interfaces/Patient';

export namespace VetoPartner {
  export const ORIGIN = 'VetoPartner';
  export const CONFIGURATION_KEY = 'veto_partner';
  export const LABEL = 'VétoPartner';
  export const DEFAULT_SPECIES_ALIASES = {
    cat: 'cat',
    dog: 'dog',
  } as const;
}
export default class VetoPartnerExporter extends PmsExporter {
  exportDataToPMS = async (
    { exportDirectory }: PMSConfigurationType = {},
    currentStudy: StudyType,
    patient: Patient,
    images: ImagesType = []
  ): Promise<PromiseSettledResult<void>[] | undefined> => {
    // PMS not configured, don't bother user with this
    if (!exportDirectory) {
      console.warn('exportDirectory is not configured cannot export data to PMS');
      return undefined;
    }

    const pmsId: string | undefined = currentStudy?.pms_id;
    if (!pmsId) {
      console.warn('Patient pms_id is required to export data to PMS');
      return undefined;
    }

    const fileId: string | undefined = patient?.file_id;
    if (!fileId) {
      console.warn('Patient file_id is required to export data to PMS');
      return undefined;
    }

    return Promise.allSettled([
      ...this.exportImages(exportDirectory, pmsId, images),
      this.exportReportPdfWithElectron(exportDirectory, fileId, currentStudy, patient, images),
    ]);
    // this.exportLink(exportDirectory, pmsId, currentStudy.ID);
    // this.exportReportDocx(exportDirectory, pmsId, currentStudy);
  };
}
